import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { ExecSummary } from "../components/ExecSummary";
import { loadDashboardData } from "../lib/api";

export default function SummaryPage() {
  const [state, setState] = useState({ loading: true, data: null });
  useEffect(() => { loadDashboardData().then((data) => setState({ loading: false, data })).catch(() => setState({ loading: false, data: null })); }, []);
  if (state.loading) return <div className="flex justify-center pt-40 text-slate-400 gap-3" data-testid="summary-loading"><Loader2 className="h-5 w-5 animate-spin" /> Building summary…</div>;
  if (!state.data?.users?.length || !state.data.hasTime) return (
    <div className="max-w-3xl mx-auto px-6 pt-28" data-testid="summary-empty">
      <h1 className="font-display text-3xl font-bold text-slate-100">No data for a summary yet.</h1>
      <Link to="/manage" className="mt-6 inline-flex px-4 py-2.5 rounded-md bg-ep hover:bg-ep-hover text-white text-sm">Go to Manage data</Link>
    </div>
  );
  return <ExecSummary raw={state.data} />;
}
